var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospitality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6458 29.5568C16.1074 29.4337 15.5711 29.7703 15.448 30.3087C15.3248 30.8471 15.6615 31.3833 16.1998 31.5065L16.6458 29.5568ZM35.5971 31.3787L36.0309 32.2798L36.8701 31.8758L36.5267 31.01L35.5971 31.3787ZM24.2388 36.8461L24.6579 37.7541L24.6653 37.7507L24.6726 37.7471L24.2388 36.8461ZM16.1998 31.5065C17.4856 31.8006 19.632 32.0869 21.9844 32.0193C24.327 31.9519 26.9708 31.531 29.1817 30.3327L28.2287 28.5744C26.4045 29.5631 24.1135 29.9572 21.9269 30.0201C19.7501 30.0827 17.7728 29.8146 16.6458 29.5568L16.1998 31.5065ZM29.1817 30.3327C30.9621 29.3678 32.1871 29.5158 32.9925 29.9113C33.8596 30.3371 34.4275 31.1422 34.6676 31.7474L36.5267 31.01C36.1507 30.0622 35.2902 28.8114 33.874 28.116C32.3963 27.3905 30.4833 27.3524 28.2287 28.5744L29.1817 30.3327ZM35.1634 30.4777L23.8051 35.945L24.6726 37.7471L36.0309 32.2798L35.1634 30.4777ZM23.8198 35.9381C23.0452 36.2956 20.4221 36.9266 17.1475 35.8925L16.5452 37.7997C20.2935 38.9834 23.4303 38.3206 24.6579 37.7541L23.8198 35.9381ZM17.1475 35.8925C13.6317 34.7823 10.2089 33.7338 8.93527 33.3479L8.35526 35.2619C9.62284 35.6461 13.0381 36.6922 16.5452 37.7997L17.1475 35.8925Z",
    fill: "#002970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0709 23.4091C8.57589 21.0373 4.35856 20.547 2.56177 20.5984V35.4604H7.79813L11.0709 23.4091Z",
    stroke: "#002970",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9939 24.7943C14.2538 25.2563 21.1894 26.2805 22.8527 26.6809C24.9319 27.1815 25.1629 29.7997 24.0078 30.8007",
    stroke: "#002970",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.135 16.8251C35.135 11.2751 30.6358 6.77588 25.0858 6.77588C19.5358 6.77588 15.0366 11.2751 15.0366 16.8251",
    stroke: "#002970",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9597 16.6324L16.6716 19.5294C16.8515 19.8339 17.1788 20.0207 17.5325 20.0207H32.5623C32.916 20.0207 33.2434 19.8339 33.4233 19.5294L35.1351 16.6324",
    stroke: "#002970",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5713 16.8248H38.5617",
    stroke: "#00BAF2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7413 6.89124V5.15862C26.7413 4.26551 26.0173 3.5415 25.1242 3.5415V3.5415C24.2311 3.5415 23.5071 4.26551 23.5071 5.15862L23.5071 6.89124",
    stroke: "#002970",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitality);
export default __webpack_public_path__ + "static/media/hospitality.6b927f41aece0d135d3f0f4c02bdff2b.svg";
export { ForwardRef as ReactComponent };